import { PREMIUM_USER_TYPE, USER_SELLER_TYPE } from 'Constants/users';

export const checkUserMembership = (type = '') => !![PREMIUM_USER_TYPE.PREMIUM, PREMIUM_USER_TYPE.SUPER_USER].includes(type);

export const checkIfPremiumUser = (type = '') => !![PREMIUM_USER_TYPE.PREMIUM, USER_SELLER_TYPE.SELLER_TYPE_PREMIUM].includes(type);

export const checkIfSuperUser = (type = '') => !![PREMIUM_USER_TYPE.SUPER_USER, USER_SELLER_TYPE.SELLER_TYPE_SUPER_USER].includes(type);
